/** CAUTION: INACTIVE = 0 is falsy. Always use strict equality (=== UserState.INACTIVE), never rely on truthiness checks. */
export let UserState = /*#__PURE__*/function (UserState) {
  UserState[UserState["INACTIVE"] = 0] = "INACTIVE";
  UserState[UserState["ACTIVE"] = 1] = "ACTIVE";
  UserState[UserState["TRASH"] = -2] = "TRASH";
  return UserState;
}({});
export let UserSource = /*#__PURE__*/function (UserSource) {
  UserSource["WEBSITE"] = "WEBSITE";
  UserSource["KH"] = "KH";
  UserSource["BIDV"] = "BIDV";
  UserSource["POS"] = "POS";
  UserSource["STORE_STAFF"] = "STORE_STAFF";
  UserSource["MISA"] = "MISA";
  UserSource["DEALER"] = "DEALER";
  UserSource["VTB"] = "VTB";
  return UserSource;
}({});
export let UserType = /*#__PURE__*/function (UserType) {
  UserType["PERSONAL"] = "personal";
  UserType["ORGANIZATION"] = "organization";
  return UserType;
}({});
export let MisaSyncState = /*#__PURE__*/function (MisaSyncState) {
  MisaSyncState["WAITING"] = "WAITING";
  MisaSyncState["SYNCING"] = "SYNCING";
  MisaSyncState["SYNCED"] = "SYNCED";
  MisaSyncState["ERROR"] = "ERROR";
  return MisaSyncState;
}({});
//# sourceMappingURL=user.enum.js.map